export const OverviewTab = {
  Status: 'Status',
  ScoreCategory: 'Score/Category',
  Score: 'Score',
  PassFail: 'PassFail',
};
